import axios from 'axios'
import { session } from '../redux/slices/authSlice'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || '',
  timeout: 15000,
})

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = session.token()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// On 401 clear session and redirect to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      session.clear()
      window.location.href = '/login'
    }
    return Promise.reject(err)
  }
)

export default api